export interface EnvironmentVariables extends NodeJS.ProcessEnv {
    REACT_APP_AptrinsicSRIHash: string
    REACT_APP_AppInsightInstrumentationKey: string
    REACT_APP_GraphQLUri: string
    REACT_APP_KPCoreUri: string
    REACT_APP_FileStack_ApiKey: string
    REACT_APP_BlobStorageUrl: string
    REACT_APP_BlobStorageAccountName: string
    REACT_APP_BlobStorageUnverifiedContainerName: string
    REACT_APP_CustomNodeEnv: string
    REACT_APP_B2C_Tenant: string
    REACT_APP_B2C_ApplicationId: string
    REACT_APP_B2C_SignInPolicy: string
    REACT_APP_BuildNumber: string
    REACT_APP_ShowFormat: string
    REACT_APP_ShowImportTab: string
    REACT_APP_ShowBestPracticesSetting: string
    REACT_APP_ShowSMM: string
    REACT_APP_EnableOMWorkspace: string
    REACT_APP_EnableVersionControl: string
    REACT_APP_NotifInterval: string
    REACT_APP_EnablePasteFromWord: string
    REACT_APP_ShowPublishUpdateButtons: string
    REACT_APP_ShowCreateWorkItemButton: string
    REACT_APP_CdnBaseUrl: string
    MASTER_ID: string
    REACT_APP_AnalyticsAPIUri: string
    REACT_APP_EnableTVSettingsReset: string
    REACT_APP_ShowSMMActionButtons: string
    REACT_APP_ShowSpecpointCopilot: string
    REACT_APP_ShowBulkActionsButton: string
    REACT_APP_ShowProductHistoryButton: string
    REACT_APP_ShowProductSelectionEnhancement: string
    REACT_APP_ShowSwatchbox: string
    REACT_APP_EnableSpectextCheckbox: string
    REACT_APP_EnableListingCountLoader: string
    REACT_APP_ShowRedesignedEditorToggle: string
    REACT_APP_HideGroupSustainabilityContentInSMM: string
    REACT_APP_EnableMasterspecWorkItemCreation: string
    REACT_APP_ShowContentLibraryOptions: string
    REACT_APP_CKEditorLicenseKey: string
    REACT_APP_CKEditorInspector: string
    REACT_APP_EnableSmartProjectCopy: string
    REACT_APP_FeatureFlag_IsHeaderFooterCopyrightEnabled: string
    REACT_APP_EnableBadgelessCards: string
    REACT_APP_EnablePPLFeature: string
    REACT_APP_EnableDynamicManufacturerListSelection: string
    REACT_APP_ShowMFACheckbox: string
    REACT_APP_ShowNotesButtonInDragIconMenu: string
    REACT_APP_ShowBestPracticesInDragIconMenu: string
    REACT_APP_NEW_WORKSPACE_CUTOFF_DATE: string
    REACT_APP_ShowBestPracticesFeatureInNewWorkspace: string
    REACT_APP_ShowSUNotifications: string
    REACT_APP_EnableBPMLimitedUpdate: string
    REACT_APP_ShowProductScraper: string
}

export const processEnv = process.env as EnvironmentVariables
export const isProduction =
    (process.env.REACT_APP_CustomNodeEnv || '').toLowerCase() === 'production'
export const isStaging =
    (process.env.REACT_APP_CustomNodeEnv || '').toLowerCase() === 'staging'
